import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Conversations from './Conversations';
import Conversation from './Conversation';
import Participant from './Participant';

function App() {
  const [solvedCaptchas, setSolvedCaptchas] = useState({});
  const [conversations, setConversations] = useState([]);

  const handleCaptchaSolve = (conv, part) => {
    setSolvedCaptchas({
      ...solvedCaptchas,
      [conv]: {
        ...solvedCaptchas[conv],
        [part]: true,
      },
    });
  };

  return (
    <Router>
      <Routes>
      <Route path="/conversation/:id" element={<Conversation solvedCaptchas={solvedCaptchas} />} />
        <Route path="/conversation/:conversationId/:participantId" element={<Participant />} />
        <Route 
          path="/" 
          element={<Conversations 
                      conversations={conversations} 
                      setConversations={setConversations} 
                      handleCaptchaSolve={handleCaptchaSolve} 
                      solvedCaptchas={solvedCaptchas} 
                    />} 
        />

      </Routes>
    </Router>
  );
}

export default App;